import { STATUS_CONFIG } from "@/lib/constants";

export default function StatusBadge({ status, size = "md", testId }) {
  const cfg = STATUS_CONFIG[status] || { label: status, color: "#48484a", bg: "#eaeaea" };
  const pad = size === "sm" ? "px-2.5 py-0.5 text-[11px]" : "px-3 py-1 text-xs";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${pad}`}
      style={{ color: cfg.color, backgroundColor: cfg.bg }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: cfg.color }} />
      {cfg.label}
    </span>
  );
}
